const config = {
  ssoConfig: {
    redirect_uri: "https://int-wifi-guest.helpline.fr/authorize_return",
    authorization: "https://login.microsoftonline.com/e1ffe413-68d6-4603-bb4e-7e95c2f0f58d/oauth2/v2.0/authorize",
    client_id: "d8b0edac-278c-4be9-bddc-5abfa1c5c1aa",
    protocol: "OAuthPKCE",
    token: "https://login.microsoftonline.com/e1ffe413-68d6-4603-bb4e-7e95c2f0f58d/oauth2/v2.0/token",
    scope: "openid profile email api://d8b0edac-278c-4be9-bddc-5abfa1c5c1aa/wifi-guest",
    response_type: "code",
    response_mode: "query",
    grant_type: "authorization_code",
  },
};
module.exports = config;
